<!--
 * @Autor: Charls
 * @Date: 2021-07-13 10:52:17
 * @LastEditTime: 2021-07-15 10:29:10
 * @LastEditors: lyy
 * @Description: 
 * @FilePath: \maine:\git\xadc\src\App.vue
-->
<template>
  <div id="app">
    <keep-alive :key="1" :include="$store.state.includes">
      <!-- <keep-alive> -->
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  mounted() {}
}
</script>

<style lang="scss">
html,
body {
  background-color: #f1f3f6;
  font-family: PingFang SC;
}
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
  background-color: #f1f3f6;
}

.dialog {
  border-radius: 5px !important;
  font-size: 19px !important;
}
</style>
